/* eslint-disable @typescript-eslint/no-explicit-any */
import * as actions from "store/actions/mei";
import IMei from "Types/IMei";

export interface MeiState {
	items: IMei[];
	filter: any[];
	pages: any;
	count: number;
	loading: any;
	errors: any;
}

interface MyAction {
	type: string;
	payload: any;
}

const initialState: MeiState = {
	items: [],
	filter: [],
	pages: null,
	count: 0,
	loading: { getAll: false, import: false },
	errors: {}
};

const reducer = function (state = initialState, action: MyAction) {
	const { type, payload } = action;
	switch (type) {
		case actions.GET_MEIS: {
			return {
				...state,
				loading: { getAll: true },
				errors: initialState.errors
			};
		}
		case actions.GET_MEIS_SUCCESS: {
			return {
				...state,
				items: payload || [],
				loading: { getAll: false }
			};
		}
		case actions.GET_MEIS_FAILED: {
			return {
				...state,
				loading: { getAll: false },
				errors: payload
			};
		}
		case actions.IMPORT_MEIS: {
			return {
				...state,
				loading: { import: true },
				errors: initialState.errors
			};
		}
		case actions.IMPORT_MEIS_SUCCESS: {
			return {
				...state,
				loading: { import: false }
			};
		}
		case actions.IMPORT_MEIS_FAILED: {
			return {
				...state,
				loading: { import: false },
				errors: payload
			};
		}

		case actions.CHANGE_MEI_OL_STATUS: {
			return {
				...state,
				loading: { statusOl: true },
				errors: initialState.errors
			};
		}
		case actions.CHANGE_MEI_OL_STATUS_SUCCESS: {
			const item: any = state.items.find(c => c._id === payload._id);

			item.logisticOperatorStatus = payload.logisticOperatorStatus;

			return {
				...state,
				items: [...state.items],
				loading: { statusOl: false }
			};
		}
		case actions.CHANGE_MEI_OL_STATUS_FAILED: {
			return {
				...state,
				loading: { statusOl: false },
				errors: payload
			};
		}
		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
